function isNullOrEmpty(value) {
    if (value === undefined || value === '' || value === null || value.trim() === '') {
        return true;
    }
    return false;
}
function setCookie(cookieName, cookieValue, expirydays) {
    const d = new Date();
    d.setTime(d.getTime() + expirydays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    let cookieValueEncoded = encodeURIComponent(cookieValue);
    document.cookie = cookieName + '=' + cookieValueEncoded + ';' + expires + ';path=/';
}
function clearCookie(cookieName) {
    setCookie(cookieName, '', -1);
}
function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

function httpPost(
    endpoint,
    requestHeaders,
    data,
    callbackSuccess,
    callbackSuccessData,
    callbackError,
    callbackErrorData
) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', endpoint);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    if (requestHeaders) {
        for (const [key, value] of Object.entries(requestHeaders)) {
            xhr.setRequestHeader(key, value);
        }
    }
    const body = JSON.stringify(data);
    xhr.onload = () => {
        if (xhr.readyState == 4 && (xhr.status == 201 || xhr.status == 200)) {
            if (callbackSuccess && typeof callbackSuccess == 'function') {
                callbackSuccess(xhr.responseText, callbackSuccessData);
            }
        } else {
            console.log(`Error: ${xhr.status}`);
            if (callbackError && typeof callbackError == 'function') {
                callbackError(xhr, callbackErrorData);
            }
        }
    };
    xhr.send(body);
}
function httpGet(endpoint, requestHeaders, callbackSuccess, callbackError) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', endpoint);
    if (requestHeaders) {
        for (const [key, value] of Object.entries(requestHeaders)) {
            xhr.setRequestHeader(key, value);
        }
    }
    xhr.send();
    xhr.responseType = 'json';
    xhr.onload = () => {
        if (xhr.readyState == 4 && xhr.status == 200) {
            //console.log(xhr.response);
            if (callbackSuccess && typeof callbackSuccess == 'function') {
                callbackSuccess(xhr.responseText);
            }
        } else {
            console.log(`Error: ${xhr.status}`);
            if (callbackError && typeof callbackError == 'function') {
                callbackError(xhr);
            }
        }
    };
}

export { isNullOrEmpty, setCookie, clearCookie, getCookie, httpGet, httpPost };
